import logo from '../skillLogos/grad.png';
import code from '../skillLogos/coding1.png';
import tool from '../skillLogos/tool1.png';

const Experiences = [
  {
    title: "Front-end ",
    place: "Intec",
    date: "2021",
    description: "Formation for developer front-end",
    logo: logo
  },
  {
    title: " Analyst Programmer ",
    place: "Tobania for BNP Paribas ",
    date: "2018-2019",
    description: "Daily management credit card and debit card (hello , maestro , visa , ...) ",
    logo: logo
  },
  {
    title: " Analyst Progammer ",
    place: "Accenture for BNp Paribas / NN insurance ",
    date: "2015-2016",
    description: "Carrying out technical analyzes for the sequoia project, ...",
    logo: logo
  },
  {
    title: " Analyst Progammer ",
    place: "Expert-team for BNp Paribas",
    date: "2013-2015",
    description: "Realization of projects  for Security , guide , card , ...",
    logo: logo
  },
  {
    title: " Analyst Progammer ",
    place: " Ordina for BNp Paribas ",
    date: "2006-2012",
    description: "Realization of projects  for back-office ,...",
    logo: logo
  },
  {
    title: " and many other adventures...  ",
    place: " Gestionique , Beaver , Axialog , Admiral, ... ",
    date: "1995-2012",
    description: "Realization of projects ,...",
    logo: logo
  },
];

export default Experiences;